import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';

const PinCodeField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return <FullInfoField label="pinCodeLabel" value={restaurantForFullInfo?.vivaWalletIsv?.pinCode} />;
};

export default PinCodeField;
